import { render } from "./SalesListPage.vue?vue&type=template&id=20baf341&scoped=true&ts=true"
import script from "./SalesListPage.vue?vue&type=script&lang=ts"
export * from "./SalesListPage.vue?vue&type=script&lang=ts"

import "./SalesListPage.vue?vue&type=style&index=0&id=20baf341&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20baf341"]])

export default __exports__